module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-4b50e4acd914dffa8b9cde62a5f6edba.png";